import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { validate, validators } from 'validate-redux-form';
import NumberFormat from "react-number-format";

const renderNumberWithIcon = ({ input, placeholder, icon, numberFormat, meta: { touched, error } }) => {
    return (
        <div className="form-group position-relative mb-3">
            <span
                className={`fa fa-${icon}`}
                style={{
                    position: 'absolute',
                    left: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#999',
                    zIndex: 10,
                    fontSize: '16px'
                }}
            ></span>
            <NumberFormat
                format={numberFormat}
                placeholder={placeholder}
                className="form-control"
                value={input.value}
                style={{
                    color: "#000",
                    paddingLeft: "45px",
                    height: "50px",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    border: "1px solid #ddd"
                }}
                onValueChange={(values) => {
                    input.onChange(values.value);
                }}
                onBlur={() => input.onBlur()}
                onFocus={input.onFocus}
            />
            {touched && error && <span className="text-danger small pl-2">{error}</span>}
        </div>
    )
}

const PasswordField = ({ input, placeholder, icon, meta: { touched, error } }) => {
    const [show, setShow] = useState(false);
    return (
        <div className="form-group position-relative mb-3">
            <span
                className={`fa fa-${icon}`}
                style={{
                    position: 'absolute',
                    left: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#999',
                    zIndex: 10,
                    fontSize: '16px'
                }}
            ></span>
            <input
                {...input}
                type={show ? "text" : "password"}
                placeholder={placeholder}
                className="form-control"
                style={{
                    color: "#000",
                    paddingLeft: "45px",
                    height: "50px",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    border: "1px solid #ddd"
                }}
            />
            <span
                className={`fa fa-eye${show ? '-slash' : ''}`}
                style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: '#999',
                    zIndex: 10
                }}
                onClick={() => setShow(!show)}
            ></span>
            {touched && error && <span className="text-danger small pl-2">{error}</span>}
        </div>
    )
}

const LoginForm = (props) => {
    const { handleSubmit } = props;
    return (
        <form name="loginForm" className="form-validate mb-lg" onSubmit={handleSubmit}>
            <Field
                name="username"
                component={renderNumberWithIcon}
                numberFormat={"#### ##### ####"}
                placeholder="No. de DPI"
                icon="user"
            />
            <Field
                name="password"
                component={PasswordField}
                placeholder="Contraseña"
                icon="lock"
            />
            <div className="text-right mt-2">
                ¿Se le olvidó la contraseña? <Link to="/forgot-password" style={{ color: '#1a4bbd', fontSize: '0.9rem' }}>Recuperar</Link>
            </div>
            <div className="buttons-box mt-4">
                <button type="submit" className="btn btn-primary btn-block btn-login font-weight-bold" style={{ height: '50px', borderRadius: '30px', fontSize: '1rem', backgroundColor: '#1a4bbd', borderColor: '#1a4bbd' }}>
                    Ingresar
                </button>
            </div>
            <div className="text-center mt-3">
                Ver estadísticas públicas <Link to="/dashboard-open" style={{ color: '#1a4bbd', fontSize: '0.9rem', fontWeight: 'bold' }}>Dashboard Abierto</Link>
            </div>
        </form>
    );
};

export default reduxForm({
    form: 'login', // a unique identifier for this form
    validate: (data) => {
        return validate(data, {
            username: validators.exists()('Este campo es requerido'),
            password: validators.exists()('Este campo es requerido'),
        });
    },
})(LoginForm);
